import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { themeGet } from '@styled-system/theme-get';
import { renderMonthOptions, renderYearOptions } from '../utils/filtersHelpers';
import {
  MonthWrapper,
  YearWrapper,
  TopicWrapper,
  AudienceWrapper,
} from '../StyledComponents';
import { StyledSelect } from '../../../shared/FormStyles';
import { Option } from '../Option';
import { constants } from '../utils';

const FiltersListWrapper = styled.div`
  background-color: ${themeGet('colors.white')};
  display: inline-block;
  padding: 0 16px;
  height: 72px;
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  margin: 0 0 15px 0px;
`;

const FiltersList = styled.div`
  display: flex;
  padding-top: 15px;
  input[type='text'] {
    margin: 0;
  }
`;

export const TileFilterSubNavComponent = props => {
  const { t } = useTranslation('edit');
  return (
    props.appLoaded && (
      <FiltersListWrapper className="js-tiles-index-filter-bar">
        <FiltersList>
          {props.activeStatus !== 'plan' && (
            <>
              <MonthWrapper>
                <StyledSelect
                  onChange={(val, act) => {
                    props.handleFilterChange(val, act, 'month');
                  }}
                  className="date-filter"
                  classNamePrefix="react-select"
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder={t('allMonths')}
                  value={props.tileStatusNav[props.activeStatus].filter.month}
                  isClearable={true}
                  options={renderMonthOptions(props.activeStatus)}
                  isSearchable={true}
                />
              </MonthWrapper>

              <YearWrapper>
                <StyledSelect
                  onChange={(val, act) => {
                    props.handleFilterChange(val, act, 'year');
                  }}
                  className="year-filter"
                  classNamePrefix="react-select"
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder={t('allYears')}
                  value={props.tileStatusNav[props.activeStatus].filter.year}
                  isClearable={true}
                  options={renderYearOptions()}
                  isSearchable={true}
                />
              </YearWrapper>
            </>
          )}

          <TopicWrapper>
            <StyledSelect
              onMenuOpen={props.populateBoardSettings}
              isLoading={props.ribbonTagsLoading}
              onChange={(val, act) => {
                props.handleFilterChange(val, act, 'ribbonTag');
              }}
              className="ribbon-tag-filter"
              classNamePrefix="react-select"
              components={{
                Option,
                IndicatorSeparator: () => null,
              }}
              placeholder={t('allTopics')}
              value={props.tileStatusNav[props.activeStatus].filter.ribbonTag}
              isClearable={true}
              options={[constants.TOPIC_SETTINGS].concat(...props.ribbonTags)}
              isSearchable={true}
            />
          </TopicWrapper>

          {props.audiencesEnabled && (
            <AudienceWrapper>
              <StyledSelect
                onMenuOpen={props.populateBoardSettings}
                isLoading={props.audienceLoading}
                onChange={(val, act) => {
                  props.handleFilterChange(val, act, 'audience');
                }}
                className="audience-filter"
                classNamePrefix="react-select"
                components={{
                  Option,
                  IndicatorSeparator: () => null,
                }}
                placeholder={t('allAudiences')}
                value={props.tileStatusNav[props.activeStatus].filter.audience}
                isClearable={true}
                options={props.audiences}
                isSearchable={true}
              />
            </AudienceWrapper>
          )}
        </FiltersList>
      </FiltersListWrapper>
    )
  );
};

TileFilterSubNavComponent.propTypes = {
  activeStatus: PropTypes.string.isRequired,
  tileStatusNav: PropTypes.object.isRequired,
  appLoaded: PropTypes.bool,
  handleFilterChange: PropTypes.func.isRequired,
  audiences: PropTypes.array,
  ribbonTags: PropTypes.array,
  populateBoardSettings: PropTypes.func.isRequired,
  audienceLoading: PropTypes.bool,
  ribbonTagsLoading: PropTypes.bool,
  audiencesEnabled: PropTypes.bool,
};

export default TileFilterSubNavComponent;
